$(document).ready(function () {
    const newsletterSpinner = $('#newsletter-spinner')
    const subscribeBtn = $('#subscribe-button')
    const newsletterEmail = $('#newsletter-email')
    const newsletterAgreement = $('#newsletter-agreement')
    const newsletterError = $('#newsletter-error')

    newsletterAgreement.change(function () {
        if ($(this).is(':checked') && $('#newsletter-email').val()) {
            enableSubscribeButton()
        } else {
            disableSubscribeButton()
        }
    })

    newsletterEmail.change(function () {
        if (newsletterAgreement.is(':checked') && $(this).val()) {
            enableSubscribeButton()
        } else {
            disableSubscribeButton()
        }
    })

    subscribeBtn.click(function () {
        subscribe(newsletterEmail.val())
    })

    function subscribe (email) {
        newsletterEmail.prop('disabled', true)
        subscribeBtn.addClass('d-none')
        newsletterSpinner.removeClass('d-none')
        $.ajax(
            {
                url: '/newsletter/subscribe',
                type: "post",
                data: {
                    email: email
                }
            })
            .done(function(data)
            {
                $('#newsletter-success').removeClass('d-none')
                newsletterEmail.css('border-color', 'green')
                newsletterSpinner.addClass('d-none')
                disableSubscribeButton()
            })
            .fail(function(error)
            {
                let errorMessage = null

                if (error.status === 422) {
                    errorMessage = "sembra che l'email inserita non sia valida."
                } else {
                    errorMessage = "qualcosa è andato storto, per favore assicurati che l'email sia corretta e riprova."
                }

                $('#newsletter-error small').text(errorMessage)
                newsletterEmail.css('border-color', '#dc3545')
                newsletterError.removeClass('d-none')
                newsletterSpinner.addClass('d-none')
                subscribeBtn.removeClass('d-none')
                enableSubscribeButton()
                newsletterEmail.prop('disabled', false)
            })
    }

    function disableSubscribeButton() {
        subscribeBtn.prop('disabled', true)
    }

    function enableSubscribeButton() {
        subscribeBtn.prop('disabled', false)
    }
})

